// @ts-nocheck
import {
    FormControl,
    Autocomplete,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    RadioGroup,
    InputAdornment,
    IconButton,
    Typography,
    Box,
} from "@mui/material";
import { Stack } from "@mui/system";
import { Button } from "../atoms";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import FormLabel from "@mui/material/FormLabel";
import { useEffect, useState } from "react";

export const ApiCredentialsModal = ({
    isOpen,
    onClose,
    onSubmit,
    apiMerchant,
    setApiMerchant,
    apiEmail,
    apiPassword,
    merchantList,
    notificationType,
    setNotificationType,
    notificationEmail,
    setNotificationEmail,
    notificationPhone,
    setNotificationPhone,
    handleSendUserInformation,
    apiUserPhoneNumber = ""
}) => {
    const [copied, setCopied] = useState({ email: false, password: false });

    const handleCopy = (value, type) => {
        navigator.clipboard.writeText(value);
        setCopied((prev) => ({ ...prev, [type]: true }));
        setTimeout(() => setCopied((prev) => ({ ...prev, [type]: false })), 1000);
    };

    const [phoneModal, setPhoneModal] = useState(apiUserPhoneNumber);

    const handlePhoneModalChange = (data) => {
        setPhoneModal(data);
        setNotificationPhone(data);
    }

    useEffect(() => {
        if (apiUserPhoneNumber) {
            setNotificationPhone(apiUserPhoneNumber);
            setPhoneModal(apiUserPhoneNumber);
            setNotificationType('sms');
        }
    }, [isOpen]);

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            onClose={(event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                    return;
                }
                onClose();
            }}
        >
            <DialogTitle sx={{ bgcolor: "grey.100", py: 2 }}>
                API Bilgileri Oluştur
            </DialogTitle>
            <DialogContent sx={{ py: 3 }}>
                <Stack spacing={3} sx={{
                    marginTop: '15px'
                }}>
                    {!apiEmail && !apiPassword ? (
                        <>
                            <FormControl fullWidth>
                                <Autocomplete
                                    value={apiMerchant}
                                    onChange={(_, newValue) => setApiMerchant(newValue)}
                                    options={merchantList || []}
                                    getOptionLabel={(option) => option.label}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Üye İşyeri" variant="outlined" />
                                    )}
                                />
                            </FormControl>
                            <Stack direction="row" justifyContent="flex-end" gap={1.5}>
                                <Button
                                    onClick={onClose}
                                    variant="outlined"
                                    text="İptal"
                                    sx={{ minWidth: 100 }}
                                />
                                <Button
                                    onClick={onSubmit}
                                    variant="contained"
                                    text="Oluştur"
                                    disabled={!apiMerchant}
                                    sx={{ minWidth: 100 }}
                                />
                            </Stack>
                        </>
                    ) : (
                        <>
                            <FormControl fullWidth>
                                <TextField
                                    label="Kullanıcı Adı"
                                    value={apiEmail}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={() => handleCopy(apiEmail, "email")} edge="end">
                                                    {copied.email ? (
                                                        <CheckIcon color="success" />
                                                    ) : (
                                                        <ContentCopyIcon />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    disabled
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <TextField
                                    label="Şifre"
                                    value={apiPassword}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => handleCopy(apiPassword, "password")}
                                                    edge="end"
                                                >
                                                    {copied.password ? (
                                                        <CheckIcon color="success" />
                                                    ) : (
                                                        <ContentCopyIcon />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    disabled
                                />
                            </FormControl>
                            <Divider sx={{ my: 2 }} />
                            <FormControl component="fieldset">
                                <FormLabel component="legend" sx={{ mb: 1 }}>
                                    Bilgilendirme Yöntemi
                                </FormLabel>
                                <RadioGroup
                                    value={notificationType}
                                    onChange={(e) => {
                                        setNotificationType(e.target.value);
                                        setNotificationEmail("");
                                        setNotificationPhone("");
                                    }}
                                >
                                    <FormControlLabel
                                        value="email"
                                        control={<Radio />}
                                        label="Email ile Gönder"
                                    />
                                    <FormControlLabel
                                        value="sms"
                                        control={<Radio />}
                                        label="SMS ile Gönder"
                                    />
                                </RadioGroup>
                            </FormControl>
                            {notificationType === "email" && (
                                <FormControl fullWidth>
                                    <TextField
                                        label="Email Adresi"
                                        type="email"
                                        value={notificationEmail}
                                        onChange={(e) => setNotificationEmail(e.target.value)}
                                        placeholder="Bilgilerin gönderileceği email adresi"
                                        variant="outlined"
                                    />
                                </FormControl>
                            )}
                            {notificationType === "sms" && (
                                <FormControl fullWidth>
                                    <TextField
                                        label="Telefon Numarası"
                                        value={phoneModal}
                                        onChange={(e) => handlePhoneModalChange(e.target.value)}
                                        placeholder="Bilgilerin gönderileceği telefon numarası"
                                        variant="outlined"
                                    />
                                </FormControl>
                            )}
                            <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
                                <Box component="span" color="error.main">
                                    *
                                </Box>{" "}
                                Güvenliğiniz için bu bilgileri kaydetmenizi öneririz. Daha sonra sistemde
                                tekrar görüntülenemez.
                            </Typography>
                        </>
                    )}
                </Stack>
            </DialogContent>
            {apiEmail && apiPassword && (
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={handleSendUserInformation}
                        variant="contained"
                        text="Gönder"
                        fullWidth
                        disabled={
                            (notificationType === "email" && !notificationEmail) ||
                            (notificationType === "sms" && !notificationPhone)
                        }
                        sx={{ maxWidth: 200, mx: "auto" }}
                    />
                </DialogActions>
            )}
        </Dialog>
    );
};